/* Escala del modo TV.

   Un televisor entrega a la app una pantalla de pocos puntos (960×540 en uno de 1080p, porque
   Android TV trabaja a densidad 2), y a ese ancho todo sale enorme y cabe poco. Aquí el modo TV se
   dibuja siempre sobre un ancho de referencia, como si la pantalla tuviera BASE_WIDTH puntos, sea
   cual sea su resolución: primero pidiéndoselo al navegador (viewport) y, si no lo concede (el
   WebView de la app no lo hace), reduciendo la página con `zoom`.

   «Tamaño de la interfaz» cambia ese ancho de referencia, así que en TV escala todo por igual:
   letra, tarjetas, botones y márgenes. */

export const BASE_WIDTH = 1366;
const MIN_SCREEN = 700;
const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1, viewport-fit=cover, user-scalable=no';

function meta() {
    return document.querySelector('meta[name="viewport"]');
}

/** Zoom que hay que aplicar para que una pantalla de `width` puntos se vea como una de `target`. */
export function zoomFor(width, target) {
    if (!(width > 0) || !(target > 0)) return 1;
    const z = width / target;
    // Si el navegador ya da (casi) el ancho pedido, no se toca nada.
    return Math.abs(z - 1) < 0.03 ? 1 : Math.round(z * 1000) / 1000;
}

export const tvscale = {
    active: false,
    target: 0,
    zoom: 1,
    _listening: false,

    /** tv: si el modo TV está activo; uiScale: «Tamaño de la interfaz» (1 = 100 %). */
    apply(tv, uiScale) {
        const scale = Math.min(1.6, Math.max(0.6, Number(uiScale) || 1));
        const screenWidth = Math.max(window.innerWidth || 0, (window.screen && window.screen.width) || 0);
        this.active = !!tv && screenWidth >= MIN_SCREEN;
        this.target = this.active ? Math.round(BASE_WIDTH / scale) : 0;
        const m = meta();
        if (m) m.setAttribute('content', this.active ? 'width=' + this.target + ', viewport-fit=cover, user-scalable=no' : DEFAULT_VIEWPORT);
        if (!this._listening) {
            this._listening = true;
            window.addEventListener('resize', () => this.fit());
        }
        this.fit();
    },

    /** Ajusta el zoom a la pantalla que hay. Se repite si cambia (p. ej. cuando el navegador concede el ancho). */
    fit() {
        const html = document.documentElement;
        const z = this.active ? zoomFor(window.innerWidth, this.target) : 1;
        this.zoom = z;
        if (z === 1) {
            html.style.zoom = '';
            html.style.removeProperty('--vw');
            html.style.removeProperty('--vh');
            return;
        }
        html.style.zoom = String(z);
        // Con zoom, 1vw y 1vh siguen midiendo la pantalla sin reducir: se dan ya corregidos.
        html.style.setProperty('--vw', (window.innerWidth / z / 100) + 'px');
        html.style.setProperty('--vh', (window.innerHeight / z / 100) + 'px');
    }
};
